import { useRef, useEffect, useState } from 'react'
import * as d3 from 'd3'

import nivel_1 from './nivel1'
import nivel_2 from './nivel2'
import nivel_3 from './nivel3'
import text from './text'

const Mapa = ({ data, size, colorPaises, colorFondo }) => {
    const svgCanvas = useRef(null)
    const audioRef = useRef(null)
    const [audio, setAudio] = useState('')
    const [abierto, setAbierto] = useState('')
    const [open, setOpen] = useState('')
    const { width, height, margin } = size
    const svgWidth = width + margin.left + margin.right
    const svgHeight = height + margin.top + margin.bottom

    let play = false
    let icono = ''
    let selected = -1

    const colores = [
        {
            icono: 'microfono',
            color: '#c4440c'
        },
        {
            icono: 'comisionados',
            color: '#064b72'
        },
        {
            icono: 'canciones',
            color: '#e93119'
        },
        {
            icono: 'radio',
            color: '#00c69d'
        },
        {
            icono: 'falsospositivos',
            color: '#ab977b'
        },
        {
            icono: 'generaciones',
            color: '#b913e2'
        },
        {
            icono: 'discapacidad',
            color: '#fd9f9d'
        },
        {
            icono: 'afro',
            color: '#890d03'
        },
        {
            icono: 'escucha',
            color: '#f06338'
        },
        {
            icono: 'indigenas',
            color: '#e9af81'
        },
        {
            icono: 'futuro',
            color: '#fbd102'
        },
        {
            icono: 'campesinado',
            color: '#591163'
        }
    ]

    useEffect(() => {
        const main_projection = d3.geoMercator()
        const svg = d3.select(svgCanvas.current)
        svg.selectAll("*").remove()

        const patternSize = 4
        const patternWidth = 2
        const patternAngle = 30
        const patternColor = colorPaises

        const defs = svg.append("defs");
        const hatchStripes = defs
            .append("pattern")
            .attr("width", patternSize)
            .attr("height", patternSize)
            .attr("patternTransform", `rotate(${patternAngle})`)
            .attr("patternUnits", "userSpaceOnUse")
            .attr("id", "hatchStripes");
        hatchStripes
            .append("line")
            .attr("x1", "0")
            .attr("x2", "0")
            .attr("y1", "0")
            .attr("y2", patternSize)
            .style("stroke", patternColor)
            .style("stroke-width", patternWidth);

        svg.append('rect')
            .attr('width', svgWidth)
            .attr('height', svgHeight)
            .attr('fill', colorFondo)



        const nivel_1_group = svg.append('g')
        const nivel_2_group = svg.append('g')
        const nivel_3_group = svg.append('g')

        let arc = d3.create("g")

        const text = svg.append('text')
            .attr('x', svgWidth / 2)
            .attr('y', svgHeight / 2 - 100)
            .attr('font-family', "'Obliqua ITC Std', sans-serif")
            .attr('font-size', 25)
            .attr('text-anchor', 'middle')
            .text('')

        const extra_group = svg.append('g')



        let arcPath = d3.arc()
            .innerRadius(55)
            .outerRadius(70)
            .startAngle(0)
            .endAngle(0)



        main_projection.fitSize([svgWidth, svgHeight], nivel_2)

        nivel_1_group.selectAll('.nivel_1')
            .data(nivel_1.features.filter(d => d.properties["iso_a2"] !== 'CO'))
            .join('path')
            .attr('class', 'nivel_1')
            .attr('d', d3.geoPath(main_projection))
            .attr('fill', `url(#hatchStripes)`)
            .attr('stroke', colorFondo)
            .attr('stroke-width', 1)

        const nivel2_node = nivel_2_group.selectAll('.nivel_2')
            .data(nivel_2.features.filter(d => d.properties['dpto_cnmbr'] !== 'ARCHIPIÉLAGO DE SAN ANDRÉS, PROVIDENCIA Y SANTA CATALINA'))
            .join('g')
            .attr('class', 'nivel_2')

        nivel2_node.append('path').attr('d', d3.geoPath(main_projection))
            .attr('fill', d => {
                return colorFondo
            })
            .attr('stroke', '#8C7F68')
            .attr('stroke-width', .5)

        const simulation = d3.forceSimulation(data)
            .force("x", d3.forceX(d => {
                const item = nivel_3.features.find(g => g.properties['mpio_ccnct'] === d.divipola)
                if (item) {
                    const coor = main_projection(d3.geoCentroid(item.geometry))
                    return coor[0]
                } else return -2000

            }))
            .force("y", d3.forceY(d => {
                const item = nivel_3.features.find(g => g.properties['mpio_ccnct'] === d.divipola)
                if (item) {
                    const coor = main_projection(d3.geoCentroid(item.geometry))
                    return coor[1]
                } else return -2000
            }))
            .force("distancia", d3.forceCollide(d => {
                return 10
            }).iterations(2))
            .on("tick", () => {
                burbujas.attr("transform", d => `translate(${d.x} ${d.y})`)
            })

        const burbujas = extra_group.selectAll(".burbujas")
            .data(data)
            .join("g")
            .attr("class", "burbujas")
            .on('click', (e, d) => {
                if (!play) {
                    play = true
                    icono = d['Icono']
                    // text.text(d['Titulo'])

                    selected = d.index
                    const arcBg = d3.select(e.path[1]).append('circle').lower()
                        .attr('cx', 0)
                        .attr('cy', 0)
                        .attr('r', 0)
                        .attr('fill', 'rgba(0,0,0,0.65)')

                    setAbierto(d['Icono'])

                    arcBg.transition().attr('r', 80)

                    arc = d3.select(e.path[1]).append('path')
                        .attr("class", "arc")
                        .attr("d", arcPath)
                        .attr("fill", "green")
                        .attr("stroke", "rgba(255,255,255,0.4)")

                    audioRef.current.ontimeupdate = () => {
                        // console.log(audioRef.current.currentTime, audioRef.current.duration)

                        let angle = 2 * Math.PI * audioRef.current.currentTime / audioRef.current.duration

                        arcPath.endAngle(angle)

                        d3.select(e.path[1]).select("path")
                            .attr("d", arcPath)
                            .attr("fill", colores.find(d => d.icono === icono).color)
                    }

                    d3.select(e.path[0]).transition().attr("width", 100).attr("height", 100).attr('transform', 'translate(-50 -50)')
                    setAudio(d.url)
                    simulation.force("distancia", d3.forceCollide((t, y) => {
                        if (d.index !== t.index) return 10
                        else return 100
                    }).iterations(2)).alpha(1).restart()
                } else if (d.index === selected) {
                    play = false
                    icono = ''
                    setAbierto('')
                    text.text('')
                    d3.select(e.path[0]).transition().attr("width", 20).attr("height", 20).attr('transform', 'translate(-10 -10)')
                    d3.select(e.path[1]).select('path').remove()
                    d3.select(e.path[1]).select('circle').remove()
                    setAudio('')
                    simulation.force("distancia", d3.forceCollide(t => {
                        return 10
                    }).iterations(2)).alpha(1).restart()
                }

            })



        burbujas.append("image")
            .attr("xlink:href", d => '/finales/' + d['Icono'] + '.png')
            .attr("width", 20)
            .attr("height", 20)
            .attr('transform', 'translate(-10 -10)')




    }, [data, size])

    return (
        <>
            <audio ref={audioRef} autoPlay src={audio} />
            <svg ref={svgCanvas} width={svgWidth} height={svgHeight}></svg>

            {abierto &&
                <>
                    <div
                        style={{
                            position: 'fixed',
                            top: 20,
                            left: 20,
                            width: 50,
                            height: 50,
                            borderRadius: 50,
                            lineHeight: '50px',
                            color: 'white',
                            textAlign: 'center'
                        }}
                        className='icon'
                        onClick={() => {
                            open ? setOpen(false) : setOpen(true)
                        }}
                    >
                        <svg
                            viewBox="0 0 416.979 416.979">
                            <g>
                                <path fill={colores.find(t => t['icono'] === abierto)['color']} d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85
		c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M237.6,340.786
		c0,3.217-2.607,5.822-5.822,5.822h-46.576c-3.215,0-5.822-2.605-5.822-5.822V167.885c0-3.217,2.607-5.822,5.822-5.822h46.576
		c3.215,0,5.822,2.604,5.822,5.822V340.786z M208.49,137.901c-18.618,0-33.766-15.146-33.766-33.765
		c0-18.617,15.147-33.766,33.766-33.766c18.619,0,33.766,15.148,33.766,33.766C242.256,122.755,227.107,137.901,208.49,137.901z"/>
                            </g>

                        </svg>

                    </div>
                </>
            }

            {abierto && open &&
                <div
                    style={{
                        position: 'fixed',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        top: 20,
                        left: 100,
                        width: 'calc(100% - 150px)',
                        height: 'calc(100% - 40px)',
                        borderRadius: 50,
                        backgroundColor: colores.find(t => t['icono'] === abierto)['color'],
                        color: 'white',
                        textAlign: 'left'
                    }}
                    className='icon'
                >
                    <p
                        style={{
                            maxWidth: 460,
                            fontSize: 18
                        }}
                    >
                        {text.find(t => t['icon'] === abierto)['text']}
                    </p>

                </div>
            }
        </>
    )
}

export default Mapa